import Grid, { GridProps } from '@mui/material/Grid';
import { forwardRef } from 'react';

interface IProps {
  children?: React.ReactNode;
}

const GridWrapper = forwardRef<HTMLDivElement, IProps & GridProps>(({ children, ...props }, ref) => (
  <Grid ref={ref} {...props}>
    {children}
  </Grid>
));

export default GridWrapper;
